<template>
  <email-form-modal
    class="text-left"
    :modal-id="modalId"
    :title="`Email Quote ${value.number}`"
    :initial-emails="email ? [email] : null"
    help-text="Enter one or more emails to send the Quote to"
    :request="submitRequest"
    @success="(quote) => $emit('input', quote)"
  />
</template>

<script>
import EmailFormModal from '@/components/shared/EmailFormModal.vue';

export default {
  name: 'QuotesEmailModal',
  components: {
    EmailFormModal,
  },
  props: {
    value: Object,
    email: String,
  },
  data() {
    return {
      modalId: `quote-${this.value.id}-email-modal`,
    };
  },
  methods: {
    submitRequest(payload) {
      return this.$quotesAPI.email(this.value.id, payload);
    },
  },
};
</script>
